const CONFIG = {
  APP_ENV: process.env.REACT_APP_ENV,
  PERSONAL_CLOUD_SERVER: process.env.REACT_APP_PERSONAL_CLOUD_SERVER,
  AUTH_SERVER: process.env.REACT_APP_AUTH_SERVER,
  RECURLY_PUBLIC_KEY: process.env.REACT_APP_RECURLY_PK,
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PK,
};

export default CONFIG;
